import { render, staticRenderFns } from "./drugClassify.vue?vue&type=template&id=b04aa876&scoped=true"
import script from "./drugClassify.vue?vue&type=script&lang=js"
export * from "./drugClassify.vue?vue&type=script&lang=js"
import style0 from "./drugClassify.vue?vue&type=style&index=0&id=b04aa876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04aa876",
  null
  
)

export default component.exports